<template>
  <div class="week">
    <v-btn @click="$emit('prevWeek')" :disabled="loadingAvailableDates" density="compact" icon>
      <v-icon small>mdi-chevron-left</v-icon>
    </v-btn>

    <span class="caption primary--text mx-3">
      {{ weekLabel }}
    </span>

    <v-btn @click="$emit('nextWeek')" :disabled="loadingAvailableDates" density="compact" icon>
      <v-icon small>mdi-chevron-right</v-icon>
    </v-btn>

    <!-- <v-btn @click="$emit('goToCurrentWeek')" :disabled="loadingAvailableDates" density="compact" rounded text>
      <span class="caption">
        {{ todayLabel }}
      </span>
    </v-btn> -->
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'SelectAvailableDatesNavigation',

  props: {
    currentWeekStart: {
      type: String,
      default: '',
    },

    currentWeekEnd: {
      type: String,
      default: '',
    },

    loadingAvailableDates: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    weekLabel() {
      try {
        const tz = moment.tz.guess()
        const startLocal = moment.tz(this.currentWeekStart, tz)
        const endLocal = moment.tz(this.currentWeekEnd, tz)
        return `${startLocal.format('DD/MM')} - ${endLocal.format('DD/MM')}`
      } catch (e) {
        return '--/-- - --/--'
      }
    },
  },

  data() {
    return {
      todayLabel: this.$t('dashboard.navigationPeriod.button.today')
    }
  },
}
</script>
